// extracted by mini-css-extract-plugin
export default {"hide":"Thumbnail_hide__D9ox5"};